import { PROCESS_SOURCE } from './schema';
import { isLocalDraftProcessId } from './functional';

function toStringValue(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value.trim();
  return String(value).trim();
}

function toStringArray(value) {
  if (Array.isArray(value)) {
    return value.map((item) => toStringValue(item)).filter(Boolean);
  }
  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
}

function newAiDraftRowId(index, stamp) {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `temp-ai-${crypto.randomUUID()}`;
  }
  return `temp-ai-${stamp}-${index}`;
}

/** Assign stable client ids so draft review editing/selection works (API rows often have no id). */
export function mapAiExtractedToDraftProcesses(processes) {
  const stamp = Date.now();
  return (Array.isArray(processes) ? processes : []).map((row, index) => {
    const existingId = String(row?.id ?? '').trim();
    const id = isLocalDraftProcessId(existingId) ? existingId : newAiDraftRowId(index, stamp);
    return {
      ...row,
      id,
      name: toStringValue(row.name ?? row.process_name),
      description: toStringValue(row.description ?? row.process_description),
      owner: toStringValue(row.owner ?? row.process_owner),
      actors: toStringArray(row.actors),
      systems: toStringArray(row.systems),
      status: toStringValue(row.status) || 'open',
      source: row.source || PROCESS_SOURCE.AI_ASSISTED,
      file_ids: Array.isArray(row.file_ids) ? row.file_ids : []
    };
  });
}
